export default __webpack_public_path__ + "locales/es/ChangeUserTypeDialog.json?hash=c3fa705845d93780ba47cfacd0f67868";